<script setup lang="ts">
defineProps<{ label: string; optional?: boolean }>()
</script>

<template>
  <div class="label">
    <p>{{ label }}</p>
    <p v-if="optional" class="label--optional">(Optional)</p>
  </div>
</template>

<style scoped lang="scss">
.label {
  display: flex;
  flex-direction: column;

  /* Todo: adjust global EP label line height to 20px */
  &--optional {
    color: var(--text-tertiary);
    line-height: 1;
  }
}
</style>
